import React from 'react';
import { __ } from '@wordpress/i18n';
import NextStepLink from '../../../../components/util/next-step-link/index';
import PreviousStepLink from '../../../../components/util/previous-step-link/index';

const SiteTypographyActions = (props) => {
	const { onNextClick, onPreviousClick, customizeStep } = props;

	return (
		<>
			<PreviousStepLink customizeStep={customizeStep} onClick={onPreviousClick} before>{__('Back', 'astra-sites')}</PreviousStepLink>
			<NextStepLink ml1 customizeStep={customizeStep} after onClick={(event) => {
				onNextClick();
			}}>{__('Maybe Later', 'astra-sites')}</NextStepLink>
		</>
	)
}

export default SiteTypographyActions;
